import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, useParams, useNavigate } from 'react-router-dom';
import './index.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SEO from './components/SEO';
// import LeadPopup from './components/LeadPopup';
import Home from './pages/Home';
import HomeInterior from './pages/Homeinterior';   // ← ADD THIS
import Projects from './pages/Projects';
import Magazine from './pages/Magazine';
import About from './pages/About';
import Consult from './pages/Consult';
import Calculator from './pages/Cost-Calculator';
import Offerings from './pages/Offerings';
import StoreLocator from './pages/Storelocator';
import Ourservices from './pages/Ourservices';
import HospitalJourney from './pages/HospitalJourney';
import Contact from './pages/Contact-us';
import HowItWorks from './pages/How-It-Works';
import Consultation from './pages/Consultation';
import OTSuiteDesign from './pages/Ot-suite-designs';
import IcuLayoutDesign from './pages/Icu-layout-designs';
import PatientWardDesign from './pages/Patient-ward-designs';
import ReceptionLobbyDesign from './pages/Reception-lobby-designs';
import DiagnosticRoomDesign from './pages/Diagnostic-room-designs';
import PharmacyDesign from './pages/Pharmacy-designs';
import NurseStationDesign from './pages/Nursing-station-designs';
import IsolationRoomDesign from './pages/Isolation-room-designs';
import PaediatricWardDesign from './pages/Paediatric-ward-designs';
import OncologyUnitDesign from './pages/Oncology-unit-designs';
import MaternitySuiteDesign from './pages/Maternity-suite-designs';
import LabPathologyDesign from './pages/Lab-pathology-designs';
import ArchitectsConstruction from './pages/Architects-Construction';
import ThreeDDesigns from "./pages/ThreeDDesigns";
import NabhConsultant from "./pages/NabhConsultant";
import PlumbingElectrical from "./pages/PlumbingElectrical";
import MedicalGases from "./pages/MedicalGases";
import Ivf from "./pages/Ivf";
import FireSafety from "./pages/FireSafety";
import Hvac from "./pages/Hvac";
import CctvNetworking from "./pages/CctvNetworking";
import NurseCalling from "./pages/NurseCalling";
import NursingStationDesigns from './pages/Nursing-station-designs';
import AccessControl from "./pages/AccessControl";
import Epbax from "./pages/Epbax";
import InteriorServices from "./pages/InteriorServices";
import ModularOperationTheatres from "./pages/ModularOperationTheatres";
import MedicalFurniture from "./pages/MedicalFurniture";
import MedicalEquipment from "./pages/MedicalEquipment";
import DialysisSetup from "./pages/DialysisSetup";
import IcuSetup from "./pages/IcuSetup";
import BiomedicalService from "./pages/BiomedicalService";
import HospitalAdministration from "./pages/HospitalAdministration";
import NabhCompliance from "./pages/NabhCompliance";
import Careers from "./pages/Careers";
import Doctorfeedback from "./pages/Doctorfeedback";
import Policies from "./pages/Policies";
import TermsAndConditions from './pages/Termsandconditions';
import Hyderabad from './pages/Hyderabad';
import Narsapur from './pages/Narsapur';
import Sangareddy from './pages/Sangareddy';
import Jangaon from './pages/Jangaon';
import Mahabubnagar from './pages/Mahabubnagar';
import Indresham from './pages/Indresham';
import Bhuvanagiri from './pages/Bhuvanagiri';
import Khammam from './pages/Khammam';
import Rajahmundry from './pages/Rajahmundry';
import Vijayawada from './pages/Vijayawada';
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function OfferingsRouter() {
  const { type } = useParams();
  return <Offerings type={type} />;
}

function NotFound() {
  const nav = useNavigate();
  return (
    <div style={{ paddingTop: 68, minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
      <div>
        <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 120, color: '#e2e2e2', lineHeight: 1 }}>404</div>
        <h2 style={{ fontFamily: "'DM Serif Display', serif", fontSize: 32, color: '#0a0a0a', marginBottom: 16 }}>Page Not Found</h2>
        <p style={{ fontSize: 15, color: '#6b6b6b', marginBottom: 32 }}>The page you're looking for doesn't exist.</p>
        <button className="btn-primary" onClick={() => nav('/')}>Back to Home</button>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <SEO />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home-interior" element={<HomeInterior />} />  {/* ← ADD THIS */}
          <Route path="/projects" element={<Projects />} />
          <Route path="/magazine" element={<Magazine />} />
          <Route path="/about" element={<About />} />
          <Route path="/consult" element={<Consult />} />
          <Route path="/cost-calculator" element={<Calculator />} />
          <Route path="/calculator/home" element={<Calculator type="home" />} />
          <Route path="/offerings" element={<Offerings />} />
          <Route path="/offerings/:type" element={<OfferingsRouter />} />
          <Route path="/store-locator"         element={<StoreLocator />} />
          <Route path="/hospital-journey"      element={<HospitalJourney />} />
          <Route path="/our-services" element={<Ourservices />} />
          <Route path="/contact-us"   element={<Contact />} />
          <Route path="/how-it-works"   element={<HowItWorks />} />
          <Route path="/consultation"   element={<Consultation />} />
          <Route path="/ot-suite-designs" element={<OTSuiteDesign />} />
          <Route path="/icu-layout-designs" element={<IcuLayoutDesign />} />
          <Route path="/patient-ward-designs" element={<PatientWardDesign />} />
          <Route path="/reception-lobby-designs" element={<ReceptionLobbyDesign />} />
          <Route path="/diagnostic-room-designs" element={<DiagnosticRoomDesign />} />
          <Route path="/pharmacy-designs" element={<PharmacyDesign />} />
          <Route path="/nursing-station-designs" element={<NurseStationDesign />} />
          <Route path="/isolation-room-designs" element={<IsolationRoomDesign />} />
          <Route path="/paediatric-ward-designs" element={<PaediatricWardDesign />} />
          <Route path="/oncology-unit-designs" element={<OncologyUnitDesign />} />
          <Route path="/maternity-suite-designs" element={<MaternitySuiteDesign />} />
          <Route path="/lab-pathology-designs" element={<LabPathologyDesign />} />
          <Route path="/architects-construction" element={<ArchitectsConstruction />} />
          <Route path="/3d-designs" element={<ThreeDDesigns />} />
          <Route path="/nabh-consultant" element={<NabhConsultant />} />
          <Route path="/plumbing-electrical" element={<PlumbingElectrical />} />
          <Route path="/medical-gases" element={<MedicalGases />} />
          <Route path="/ivf" element={<Ivf />} />
          <Route path="/fire-safety" element={<FireSafety />} />
          <Route path="/hvac" element={<Hvac />} />
          <Route path="/cctv-networking" element={<CctvNetworking />} />
          <Route path="/nurse-calling" element={<NurseCalling />} />
          <Route path="/access-control" element={<AccessControl />} />
          <Route path="/epbax" element={<Epbax />} />
          <Route path="/interior-services" element={<InteriorServices />} />
          <Route path="/modular-operation-theatres" element={<ModularOperationTheatres />} />
          <Route path="/medical-furniture" element={<MedicalFurniture />} />
          <Route path="/medical-equipment" element={<MedicalEquipment />} />
          <Route path="/dialysis-setup" element={<DialysisSetup />} />
          <Route path="/icu-setup" element={<IcuSetup />} />
          <Route path="/biomedical-service" element={<BiomedicalService />} />
          <Route path="/hospital-administration" element={<HospitalAdministration />} />
          <Route path="/nabh-compliance" element={<NabhCompliance />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/doctor-feedback" element={<Doctorfeedback />} />
          <Route path="/policies" element={<Policies />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/narsapur" element={<Narsapur />} />
<Route path="/sangareddy" element={<Sangareddy />} />
<Route path="/jangaon" element={<Jangaon />} />
<Route path="/mahabubnagar" element={<Mahabubnagar />} />
<Route path="/indresham" element={<Indresham />} />
<Route path="/bhuvanagiri" element={<Bhuvanagiri />} />
<Route path="/khammam" element={<Khammam />} />
<Route path="/hyderabad" element={<Hyderabad />} />
<Route path="/rajahmundry" element={<Rajahmundry />} />
<Route path="/vijayawada" element={<Vijayawada />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
        {/* <LeadPopup /> */}
    </BrowserRouter>
  );
}